import React from 'react';
import Header from '../../../components/ui/Header';

const LoadingSkeleton = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-blue-900 to-purple-900">
      <Header />
      <main className="container mx-auto px-6 py-8 max-w-6xl">
        {/* Title Skeleton */}
        <div className="mb-8">
          <div className="h-8 bg-white bg-opacity-20 rounded-lg w-64 mb-2 animate-pulse"></div>
          <div className="h-4 bg-white bg-opacity-10 rounded-lg w-96 animate-pulse"></div>
        </div>

        {/* Search Bar Skeleton */}
        <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-6 mb-6">
          <div className="space-y-4">
            <div className="h-12 bg-white bg-opacity-10 rounded-lg animate-pulse"></div>
            <div className="flex gap-4">
              <div className="h-10 bg-white bg-opacity-10 rounded-lg w-32 animate-pulse"></div>
              <div className="h-10 bg-white bg-opacity-10 rounded-lg w-28 animate-pulse"></div>
              <div className="h-10 bg-white bg-opacity-10 rounded-lg w-36 animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Controls Skeleton */}
        <div className="flex justify-between items-center mb-6">
          <div className="h-10 bg-white bg-opacity-10 rounded-lg w-24 animate-pulse"></div>
          <div className="h-10 bg-white bg-opacity-10 rounded-lg w-32 animate-pulse"></div>
        </div>

        {/* Badge List Skeleton */}
        <div className="space-y-4">
          {[1, 2, 3, 4, 5]?.map((index) => (
            <div key={index} className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-6">
              <div className="flex items-start gap-4">
                {/* Badge Icon Skeleton */}
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-lg animate-pulse"></div>
                
                {/* Badge Content Skeleton */}
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="h-6 bg-white bg-opacity-20 rounded-lg w-48 animate-pulse"></div>
                    <div className="h-6 bg-white bg-opacity-10 rounded-full w-16 animate-pulse"></div>
                    <div className="h-6 bg-white bg-opacity-10 rounded-full w-20 animate-pulse"></div>
                  </div>
                  <div className="h-4 bg-white bg-opacity-10 rounded-lg w-full mb-1 animate-pulse"></div>
                  <div className="h-4 bg-white bg-opacity-10 rounded-lg w-2/3 mb-3 animate-pulse"></div>
                  <div className="flex gap-6">
                    <div className="h-4 bg-white bg-opacity-10 rounded-lg w-20 animate-pulse"></div>
                    <div className="h-4 bg-white bg-opacity-10 rounded-lg w-16 animate-pulse"></div>
                    <div className="h-4 bg-white bg-opacity-10 rounded-lg w-24 animate-pulse"></div>
                  </div>
                </div>
                
                {/* Action Buttons Skeleton */}
                <div className="flex gap-2">
                  <div className="w-8 h-8 bg-white bg-opacity-10 rounded-lg animate-pulse"></div>
                  <div className="w-8 h-8 bg-white bg-opacity-10 rounded-lg animate-pulse"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Skeleton */}
        <div className="mt-8 pt-6 border-t border-white border-opacity-20">
          <div className="flex justify-between">
            <div className="h-4 bg-white bg-opacity-10 rounded-lg w-32 animate-pulse"></div>
            <div className="h-4 bg-white bg-opacity-10 rounded-lg w-36 animate-pulse"></div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoadingSkeleton;